/**
 * Marks an element that must not be on screen when a frame is grabbed.
 *
 * **This is a readiness gate, not a filter.** The capture is a pixel copy of the
 * real tab (`capture-page.util.ts`), so there is no DOM to filter — anything
 * still painted when the frame lands is in the picture, full stop. Instead,
 * `capturePage` waits until nothing matching this attribute is in the document
 * before it grabs, which is what lets the launcher's 195ms exit transition
 * finish without a magic-number sleep.
 *
 * Put it on launcher-owned chrome only. Tagging ordinary UI would stall every
 * capture until that UI unmounted — and ordinary UI is usually the thing the
 * user is trying to photograph.
 *
 * Its own module, with no imports, so tagging an element does not drag the
 * capture pipeline into that component's graph.
 */
export const SCREENSHOT_BLOCKING_ATTRIBUTE = "data-suno-screenshot-blocking";

export const SCREENSHOT_BLOCKING_SELECTOR = `[${SCREENSHOT_BLOCKING_ATTRIBUTE}]`;
